/**
 * @module UseVoipAgentFiltering
 * @description Phase 16 extraction of caller/callee filter helpers for the VoIP participant picker.
 * Memoizes filtered option lists so the orchestration hook can stay focused on form state.
 */

import { useMemo } from 'react';

function matchesAgentFilter(agent, filterText) {
    const lowerFilter = filterText.toLowerCase();

    return agent.name?.toLowerCase().includes(lowerFilter) || agent.interfaceName?.toLowerCase().includes(lowerFilter);
}

export function useVoipAgentFiltering({ agents, agentsById, selectedCallerId, callerFilterText, calleeFilterText }) {
    const filteredCallerAgents = useMemo(() => {
        if (!callerFilterText) {
            return agents;
        }

        return agents.filter((agent) => matchesAgentFilter(agent, callerFilterText));
    }, [agents, callerFilterText]);

    const filteredCalleeAgents = useMemo(() => {
        let filtered = agents;

        if (selectedCallerId) {
            const selectedCaller = agentsById[selectedCallerId];

            if (selectedCaller) {
                filtered = filtered.filter((agent) => agent.useDirectCalling === selectedCaller.useDirectCalling);
            }
        }

        if (calleeFilterText) {
            filtered = filtered.filter((agent) => matchesAgentFilter(agent, calleeFilterText));
        }

        return filtered;
    }, [agents, agentsById, selectedCallerId, calleeFilterText]);

    return {
        filteredCallerAgents,
        filteredCalleeAgents,
    };
}
